const JobTypes = {
  AUDIO: 'audio',
  VIDEO: 'video',
  WHATSAPP: 'whatsapp',
}

export default JobTypes
